<template>
  <q-page fluid style="min-height: 0px">
    <div class="row full-width">
      <div class="col-12">
        <q-card class="full-width" style="min-height: calc(100vh - 190px)">
          <q-card-section class="bg-white text-accent">
            <div class="row items-center q-pa-md">
              <div class="col-12 col-md-3 col-xl-2">
                <div class="profileImageContainer" style="position: relative">
                  <q-btn
                    @click="uploadData()"
                    :loading="imageUploading"
                    color="grey"
                    class="float-left"
                    icon="mdi-camera-plus"
                    flat
                    style="position: absolute; z-index: 2; right: 0"
                  >
                  </q-btn>
                  <q-input
                    ref="uploadDataInput"
                    style="display: none"
                    v-model="file"
                    type="file"
                    label="Standard"
                    accept=".jpg, .jpeg, .png, "
                  ></q-input>
                  <q-img
                    :src="currentUserData.profileImageUrl"
                    style="border-radius: 5px"
                  >
                  </q-img>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div
                  :class="{ 'q-ml-md': $q.screen.gt.md }"
                  class="q-pa-md profileTextContainer"
                >
                  <h3 class="q-mb-none">
                    {{ currentUserData.name }}
                  </h3>
                  <p class="q-mb-none q-mr-xl">
                    {{ currentUserData.email }}
                  </p>
                  <p class="text-capitalize">
                    {{ currentUserData.role }}
                  </p>
                  <br />
                  <q-btn
                    v-if="
                      currentUserData.auth0_id &&
                      currentUserData.role != 'Official'
                    "
                    label="Change Password"
                    no-caps
                    class="bg-primary text-white"
                    @click="changePasswordDialog = true"
                  ></q-btn>
                </div>
              </div>
              <div class="col-12 col-md-3 col-xl-4">
                <div class="row">
                  <div class="col-12">
                    <!-- <p
                      style="font-weight: bold !important; font-size: 20px"
                      class="q-mb-none"
                    >
                      Association
                    </p> -->
                    <div
                      class="row"
                      v-if="currentUserData.associations.length > 0"
                    >
                      <div>
                        <div style="width: 140px; height: 75px; margin: auto">
                          <q-img
                            :src="currentUserData.currentAssociation.capUrl"
                          ></q-img>
                        </div>
                        <div style="font-weight: bold; text-align: center">
                          {{
                            currentUserData.currentAssociation.association_name
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </q-card-section>

          <q-separator />

          <q-card-section class="profileContentContainer">
            <div class="row q-px-lg">
              <div class="col-12 col-md-6 col-lg-4">
                <div class="row">
                  <div class="col-12" v-if="currentUserData.membersData">
                    <h3 class="q-my-xs">General Info</h3>
                  </div>
                  <div class="col-12" v-if="currentUserData.membersData">
                    <b>PAM ID:</b> {{ currentUserData.membersData.crm_id }}
                  </div>
                  <div class="col-12" v-if="currentUserData.membersData">
                    <b>DOB:</b> {{ currentUserData.membersData.birthDate }}
                  </div>
                  <div class="col-12" v-if="currentUserData.membersData">
                    <b>Gender:</b>
                    {{
                      currentUserData.membersData.gender == "F"
                        ? "Female"
                        : "Male"
                    }}
                  </div>
                  <div class="col-12" v-if="currentUserData.membersData">
                    <b>Phone:</b> {{ currentUserData.membersData.mobilePhone }}
                  </div>
                  <div class="col-12" v-if="currentUserData.membersData">
                    <b>Email:</b> {{ currentUserData.membersData.emailAddress }}
                  </div>
                  <div class="col-12" v-if="currentUserData.membersData">
                    <b>Ethnicity:</b>
                    {{ currentUserData.membersData.ethnicityPrimary }}
                  </div>
                </div>
              </div>
              <div
                class="col-12 col-md-6 col-lg-4"
                v-if="currentUserData.membersData"
              >
                <div class="row">
                  <div class="col-12">
                    <h3 class="q-my-xs">Postal Address</h3>
                  </div>
                  <!-- <pre>{{ currentUserData }}</pre> -->
                  <div
                    class="col-12"
                    v-if="currentUserData.membersData.postalAddress1"
                  >
                    <b>Line 1:</b>
                    {{ currentUserData.membersData.postalAddress1 }}
                  </div>
                  <div
                    class="col-12"
                    v-if="currentUserData.membersData.postalAddress3"
                  >
                    <b>Line 2:</b>
                    {{ currentUserData.membersData.postalAddress3 }}
                  </div>
                  <div
                    class="col-12"
                    v-if="currentUserData.membersData.physicalCity"
                  >
                    <b>City:</b> {{ currentUserData.membersData.physicalCity }}
                  </div>
                </div>
              </div>
            </div>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <q-dialog v-model="changePasswordDialog" persistent max-width="600px">
      <q-card
        v-if="changePasswordDialog"
        tile
        style="width: 600px; max-width: 90vw"
      >
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              Change Password
            </div>
            <q-space />
            <q-btn
              round
              flat
              icon="mdi-close"
              @click="
                changePasswordDialog = false;
                currentPassword = '';
                newPassword = '';
                confirmPassword = '';
              "
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="q-pa-none">
          <q-form ref="changePasswordForm">
            <div class="row q-pa-md">
              <div class="col-12">
                <q-input
                  label="New Password"
                  :rules="passwordRules"
                  required
                  v-bind="siteCFG.fields.general"
                  v-model="newPassword"
                  type="password"
                ></q-input>
              </div>
              <div class="col-12">
                <q-input
                  label="Confirm Password"
                  :rules="[(v) => v == newPassword || 'Passwords Must Match']"
                  required
                  v-bind="siteCFG.fields.general"
                  v-model="confirmPassword"
                  type="password"
                ></q-input>
              </div>
            </div>
          </q-form>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="updatePassword"
                :loading="updatingPassword"
                color="primary"
                no-caps
                class="float-right"
              >
                <q-icon
                  name="mdi-content-save"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Submit
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
  import { mapGetters } from "vuex";
  import moment from "moment";

  export default {
    components: {},
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        siteCFG: "settings/siteCFG",
      }),
    },
    props: {
      source: String,
    },
    watch: {
      currentUserData: function () {
        this.formData = JSON.parse(JSON.stringify(this.currentUserData));
      },
      file: function () {
        if (this.file != null) {
          this.uploadDataReady();
        }
      },
    },
    data: () => ({
      // Change Password
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => (v && v.length >= 8) || "Password must have 8+ characters",
        (v) =>
          (v && /(?=.*[A-Z])/.test(v)) ||
          "Password Must contain a capital letter",
        (v) =>
          (v && /(?=.*[a-z])/.test(v)) ||
          "Password Must contain a lowercase letter",
        (v) => (v && /.*[0-9].*/.test(v)) || "Password Must contain a number",
        (v) =>
          (v && /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(v)) ||
          "Password must have a special character",
      ],
      changePasswordDialog: false,
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
      updatingPassword: false,

      // File
      file: null,
      imageUploading: false,
    }),
    mounted() {
      this.formData = JSON.parse(JSON.stringify(this.currentUserData));
    },
    methods: {
      save() {
        this.$store
          .dispatch("users/saveProfile", this.formData)
          .then((result) => {
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: result.Response.Message,
              });
            }
          });
      },
      uploadData() {
        this.$refs.uploadDataInput.$el.click();
      },
      uploadDataReady() {
        this.imageUploading = true;
        let reader = new FileReader();
        reader.readAsDataURL(this.file[0]);
        reader.onload = () => {
          this.$store
            .dispatch("users/changeProfileImage", {
              data: reader.result,
            })
            .then((result) => {
              this.imageUploading = false;
              if (result.Result == "Success") {
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message,
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: result.Response.Message,
                });
              }
            });
        };
      },

      // Update Password
      updatePassword() {
        this.updatingPassword = true;
        this.$store
          .dispatch("auth/updatePassword", {
            newPassword: this.newPassword,
          })
          .then((result) => {
            this.updatingPassword = false;
            if (result.Result == "Success") {
              this.newPassword = "";
              this.confirmPassword = "";
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: result.Response.Message,
              });
            }
          });
      },
    },
  };
</script>

<style scoped lang="scss">
  .profileImageContainer {
    max-width: 270px;
    margin: auto;
  }
  .profileContentContainer {
    h3 {
      font-size: 25px;
      font-weight: bold;
    }
  }

  .profileTextContainer {
    h3 {
      font-size: 40px;
      font-weight: bold;
    }

    p {
      font-weight: bold;
      display: inline-block;
    }
  }
</style>
